import React, { useEffect, useState, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../context/UserContext";

const ProtectedRoute = () => {
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const { user, setUser } = useContext(UserContext);
    const token = localStorage.getItem("userToken");

    useEffect(() => {
        const checkUser = async () => {
            if (!user) {
                await fetchUser();
            }
            setLoading(false);
        };
        checkUser();
    }, [localStorage.getItem("userToken")]);

    const fetchUser = async () => {
        if (token) {
            fetch(`${API_BASE_URL}/User/profile`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((res) => res.json())
                .then((data) => {
                    const userData = {
                        username: data.username,
                        avatar:
                            `${API_BASE_URL}` + data.imageAddress ||
                            "https://images.unsplash.com/photo-1488161628813-04466f872be2?fm=jpg&q=60&w=3000",
                        admin: data.isAdmin,
                        isAdmin: data.isAdmin, // اضافه کردن isAdmin برای سازگاری
                    };
                    setUser(userData);
                })
                .catch((err) => {
                    console.error("خطا در دریافت اطلاعات کاربر:", err);
                    setUser(null);
                });
        } else {
            setUser(null);
        }
    };

    if (loading) return <div>در حال بارگذاری...</div>;

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (!user){
      return <Navigate to="/" replace />;
    }
    // بررسی هر دو مقدار admin و isAdmin
    if (!user.admin && !user.isAdmin) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;